var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFundada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#98CBC2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.1,39.8c0,0-14-2.2-11.8,11.8C46.3,53.8,44.1,39.8,44.1,39.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 40.4,
    y1: 43.5,
    x2: 32.3,
    y2: 51.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,39.8c0,0,14-2.2,11.8,11.8C17.8,53.8,20.1,39.8,20.1,39.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.7,
    y1: 43.5,
    x2: 31.8,
    y2: 51.6
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 32.1,
    y1: 60.5,
    x2: 32.1,
    y2: 51.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    y: 33,
    className: "st0",
    width: 44.6,
    height: 27.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.7,10.9 40.1,10.9 40.1,17.1 49.7,24.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.1,10.9 3.6,33 60.6,33  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.5,
    y1: 60.5,
    x2: 60.7,
    y2: 60.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundada);
export default __webpack_public_path__ + "static/media/fundada.c9fe2529aedc9f3d41d59d6dad050f7c.svg";
export { ForwardRef as ReactComponent };